export default __webpack_public_path__ + "static/media/019-statue of unity.f473f46d.svg";